import { apiSlice } from "../apiSlice";
// export const Activesizelist = createAsyncThunk('/activesizelist', async () => {
//   const response = await ApiHelperFunction({
//     urlPath: 'size/active/size',
//     method: 'GET',
//   });
//   return response;
// });
export const termsConditionSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        termsConditionlist: builder.query({
            query: (data) => ({
                url: 'termsAndCondition',
                method: 'GET',
                credentials: "include",
            }),
            providesTags: ['termsCondition']

        }),
        Create_Update_termsCondition: builder.mutation({
            query: (data) => ({
                url: 'termsAndCondition',
                method: 'POST',
                body: data,
                credentials: "include",
            }),
            invalidatesTags: ['termsCondition']

        }),

    }),
});

export const {
    useCreate_Update_termsConditionMutation,
    useTermsConditionlistQuery
} = termsConditionSlice;

